import { observer } from 'mobx-react-lite'
import { BulkEditPriceDialog } from '@/features/admin/bundle/BulkEditPriceDialog'
import { type BulkEditPriceDialogViewModel } from './BulkEditPriceDialogViewModel'

export interface BulkEditPriceDialogContainerProps {
  vm: BulkEditPriceDialogViewModel
}

export const BulkEditPriceDialogContainer = observer(
  function BulkEditPriceDialogContainer({
    vm,
  }: BulkEditPriceDialogContainerProps) {
    return (
      <BulkEditPriceDialog
        showing={vm.modal.showing}
        onClose={vm.modal.close}
        bundles={vm.eligibleBundles.map((bundle) => ({
          id: bundle.id,
          name: bundle.name,
          price: bundle.price,
          newPrice: vm.priceFor(bundle.id),
        }))}
        onNewPriceChange={vm.setPrice}
        hasEligibleBundles={vm.hasEligibleBundles}
        hasArchivedBundles={vm.hasArchivedBundles}
        archivedCount={vm.archivedCount}
        canApply={vm.canApply}
        onSubmit={vm.submit}
        isSubmitPending={vm.submit.pending}
        testId="bulk-edit-price"
      />
    )
  },
)
